<template>
  <!-- <transition name="fade" mode="out-in"> -->
  <div
      :class="{'collapsed': value}"
      ref="sidebarbackground"
      class="aside-content-sidebar word-break"
  >
    <div class="aside-sidebar--background"></div>
    <div
        :class="`flex column aside-sidebar aside-sidebar-position-${position}`"
        v-loading="feedLoading"
    >
      <div class="box heading">
        <span @click="close" class="close-sidebar" v-if="showClose">
          <i class="far fa-times"></i>
        </span>
        <slot name="title"></slot>
      </div>
      <slot name="content"></slot>
      <slot name="no-content"></slot>
      <slot name="footer"></slot>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>

export default {
  name: "AsideSidebar",
  props: {
    value: {
      default: true,
      type: Boolean
    },
    position: {
      default: "right",
      type: String
    },
    parent: {
      default: null,
      type: [String, Object]
    },
    sibling: {
      default: null,
      type: [String, Object]
    },
    feedLoading: {
      default: true,
      type: Boolean
    },
    showClose: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({}),
  watch: {
    value() {
      if (!this.value) {
        this.addEventClick();
      }
    }
  },
  mounted() {
    this.insertBody();
  },
  methods: {
    addEventClick() {
      window.addEventListener("click", this.closeSidebar);
    },
    closeSidebar(evt) {
      // this sidebar is listening on global windows event, remove after exit
      let parent = evt.target.closest(".aside-sidebar");
      if (!parent) {
        this.$emit("input", true);
        window.removeEventListener("click", this.closeSidebar);
      }
    },
    close(ev) {
      this.$emit("input", true);
      window.removeEventListener("click", this.closeSidebar);
    },
    insertBody() {
      if (this.parent) {
        let bgElem = this.$refs.sidebarbackground;
        let parentElem = document.querySelector(this.parent);
        if (parentElem) parentElem.insertBefore(bgElem, parentElem.firstChild);
      }
    }
  },
  beforeDestroy: function () {
    let element = document.getElementsByClassName("aside-content-sidebar");
    if (element.length > 0) {
      for (let i = 0; i < element.length; i++) {
        element[i].remove();
      }
    }
    // this sidebar is listening on global windows event, remove after exit
    window.removeEventListener("click", this.closeSidebar);
  },
  destroyed() {
    // Ensure the event listener is removed when the component is destroyed
    window.removeEventListener("click", this.closeSidebar);
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.close-sidebar {
  position: relative;
  left: 100%;
  right: 8px;
  color: var(--gray-600);
  cursor: pointer;
}

.collapsed {
  visibility: hidden;
  display: none;
  flex: none;
  width: 0;
}

.heading {
  margin: 10px 20px;
}

.aside-content-sidebar {
  transition: flex 2s, width 0.5s ease;
}

.aside-sidebar {
  height: 100%;
  width: 360px;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 1999;
  transition: flex 2s, width 0.5s ease;
}

.aside-sidebar.aside-sidebar-position-right {
  left: auto;
  right: 0;
  position: absolute;
  transition: flex 2s, width 0.5s ease;
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.aside-sidebar--background {
  background: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  transition: background-color 0.2s ease;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/AsideSidebar.vue